<template>
  <el-card
    v-loading="loading"
    shadow="never">
    <el-form
      :model="form"
      :rules="rules"
      class="el-form-width"
      ref="form"
      label-width="100px"
      @submit.native.prevent>
      <el-form-item
        prop="classCode"
        label="资讯分类"
      >
        <el-select
          @change="selNesClass"
          v-model="form.classCode"
          clearable
          placeholder="请选择资讯分类" disabled>
          <el-option
            v-for="item in newsClassOption"
            :key="item.classCode"
            :label="item.name"
            :value="item.classCode"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-upload
        class="avatar-uploader"
        :action="imgApi"
        accept="image"
        :show-file-list="false"
        :on-success="uploadSuccess"
        :on-error="uploadError"
        :before-upload="beforeUpload" disabled>
        <img v-if="imageUrl" :src="imageUrl" class="avatar" disabled>
        <span v-if="!imageUrl" class="avatar-uploader-icon" disabled>暂无图片</span>
      </el-upload>
      <el-form-item
        class="customizeCss"
        prop="title"
        label="标题"
      >
        <el-input type="text" v-model="form.title" placeholder="请填写标题" readonly></el-input>
      </el-form-item>
      <el-form-item
        prop="subTitle"
        label="副标题"
      >
        <el-input type="text" v-model="form.subTitle" placeholder="请填写副标题" readonly></el-input>
      </el-form-item>
      <el-form-item
        prop="seqNum"
        label="排序号"
      >
        <el-input type="number" v-model="form.seqNum" placeholder="请填写排序号" readonly></el-input>
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item
          prop="source"
          label="文章来源"
        >
          <el-input type="textarea" v-model="form.source" placeholder="请填写文章来源" readonly></el-input>
        </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
          prop="remark"
          label="备注"
          class="ipt-textarea"
        >
          <el-input type="textarea" v-model="form.remark" placeholder="请填写备注" resize="none" readonly></el-input>
        </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="文章内容：" prop="content">
        <quill-editor v-loading="loading"
                      class="content-des"
                      v-model="form.content"
                      ref="basicQuillEditor"
                      :options="editorOption" readonly>
        </quill-editor>
        <el-upload
          class="avatar-uploader"
          id="basic-uploader"
          accept="image"
           disabled>
        </el-upload>
      </el-form-item>
      <div class="tc">
        <el-button
          style="width: 140px"
          @click="goBack">关闭
        </el-button>

      </div>
    </el-form>
  </el-card>
</template>

<script>
import {news} from '../../api'
import {getSession} from '../../utils/session'
import {ORG_CODE, USER_ID} from '../../constants'

export default {
  name: 'NewsArticleDetail',
  props: {
    newsId: String
  },
  components: {
  },
  mounted () {
    if (this.newsId) {
      this.getNewsDetail()
    }
    this.getNewsClass()
    this.$refs.basicQuillEditor.quill.enable(false)
  },
  data () {
    return {
      loading: false,
      newsClassOption: [],
      imageUrl: '',
      form: {
        newsId: '',
        orgCode: getSession(ORG_CODE),
        type: '1',
        classCode: this.$route.params.classCode,
        className: this.$route.params.className,
        title: '',
        subTitle: '',
        source: '',
        content: '',
        coverImgs: '',
        seqNum: '',
        createUser: getSession(USER_ID),
        remark: ''
      },
      editorOption: {
        placeholder: '请填写文章内容',
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'], // toggled buttons
              [{'header': [1, 2, 3, 4, 5, 6, false]}],
              [{'color': []}, {'background': []}], // dropdown with defaults from theme
              [{'font': []}],
              [{'align': []}],
              ['link']
            ]
          }
        }
      }
    }
  },
  methods: {
    async getNewsClass () {
      let {data} = await news.listNewsClass({orgCode: getSession(ORG_CODE)})
      this.newsClassOption = data
    },
    async getNewsDetail () {
      this.loading = true
      let {data} = await news.getNewsDetail(this.newsId)
      console.log(data)
      this.loading = false
      if (data.coverImgs) {
        this.imageUrl = process.env.VUE_APP_IMG + data.coverImgs
      }
      delete data.createTime
      this.form = data
    },
    async goBack () {
      this.$closeCurrentView()
      this.$router.back()
    }
  }
}
</script>
<style lang="scss" scoped>
  .el-form-width {
    width: 800px;
  }
  .el-card {
    border: none;
    /deep/ .el-card__body {
      padding-top: 30px;
      .el-form {
        &.el-form--inline {
          width: 745px;
        }
        .el-form-item__content,
        .el-date-editor.el-input,
        .el-input--suffix {
          width: 300px;
        }
        .ipt-textarea {
          display: block;
          .el-form-item__content {
            width: 300px;
          }
        }
      }
      .avatar-uploader .el-upload,
      .avatar-uploader .el-upload--text {
        margin-left: 550px;
        margin-top: -58px;
      }
      .customizeCss {
        margin-top: -125px;
      }
      .form-upload-video .el-form-item__content,
      .form-upload-video .avatar-upload-video{
        width: 100%;
      }
      .avatar-upload-video .el-upload {
        width: 100%;
        height: 300px;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .avatar-upload-video .el-upload:hover {
        border-color: #409EFF;
      }
      .avatar-upload-video .avatar-uploader-icon {
        font-size: 16px;
        color: #8c939d;
        width: 100%;
        height: 300px;
        line-height: 300px;
        text-align: center;
      }
      .avatar-upload-video .avatar {
        width: 178px;
        height: 178px;
        display: block;
      }
    }
  }

  .el-input__icon {
    margin-right: 8px;
  }
  .content-des {
    height: 300px;
    width: 700px;
    border-color: #dfe1e7;
  }

</style>
<style >
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader .avatar-uploader-icon {
    display: block;
    font-size: 14px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;;
    text-align: center;
  }

  .avatar-uploader .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .video-js {
    width: 700px;
    height: 300px;
    margin-bottom: 6px;
  }
</style>
